import { LOADER } from "resources/actionTypes";

const initialSettings = {
  showLoader: false,
};
export const commonReducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialSettings;
  }
  switch (action.type) {
    case LOADER.LOADER_TRIGGER:
      return {
        ...state,
        showLoader: action.payload,
      };
    default:
      return state;
  }
};
